import JobInfoTagsSection from '@components/ka-ui/job-info-tags-section/JobInfoTagsSection';
import { PositionElement } from '@models/positions';
import React from 'react';
import { changeDateFormat } from '@services/date/date-format';
import styles from './PositionCard.module.scss';

type PositionProps = {
  position: PositionElement;
};

const PositionCard: React.FC<PositionProps> = ({ position }) => {
  return (
    <div className={styles.positionCardWrap}>
      <h3 className={styles.title}>{position.title}</h3>
      <div className={styles.tags}>
        <JobInfoTagsSection
          location={position.location ? position.location : '-'}
          occupationType={position.employment_type ? position.employment_type : '-'}
          createdDate={position.date_inserted ? changeDateFormat(new Date(position.date_inserted)) : '-'}
        />
      </div>
    </div>
  );
};

export default PositionCard;
